import { useState, useEffect, useContext } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { delimitationService } from "../services/DelimitationService";
import { changeLang } from "../componets/Language/ChangeLang";
import AddDermacation from "../componets/AddDermacation";
import { DermacationLevels, permissionLookUp } from "../constants";
import { AppDB } from "../App";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import MoveDelimitations from "./delimitations/MoveDelimitations";
import { fetchRegistrationCentres } from "./ResultManagement/services/api";
import { ProgressSpinner } from "primereact/progressspinner";
import ScreenLoader from "../componets/ScreenLoader";
import { authenticationService } from "../services/AuthenticationService";

export const DelimitationManagement = () => {
	const [nodes, setNodes] = useState([]);
	const [selectedNodeKey, setSelectedNodeKey] = useState(null);
	const [dialogVisible, setDialogVisible] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [nodeName, setNodeName] = useState("");
	const [targetNode, setTargetNode] = useState(null);

	const [isLoading, setIsLoading] = useState(false);

	const [selectedDemarcation, setSelectedDemarcation] = useState(1);
	const [moveDermacation, setmoveDermacation] = useState(false);
	const [dermacationForm, setdermacationForm] = useState({
		//Demarcation structure
		districtID: "", //Level 1
		districtName: "", //Level 1
		constituencyID: "", //Level 2
		constituencyName: "",
		votingDistrictID: "", //Level 3
		votingDistrictName: "",
		registrationCentreID: null, //Level 4
		registrationCentreName: "",
		villageID: null, //Level 5
		villageName: "",

		//selected Demarcation values
		DelimitationID: null,
		DelimitationLevelID: null,
		DelimitationParantID: null,
		registrationCenterNAID: null, //If level 5/Village
		registrationCenterLGID: null //if leve5/village
	});

	const { permission, toast, lookUp } = useContext(AppDB);
	const fetchDistricts = (demarcationType) => {
		setIsLoading(true);
		if (demarcationType.id === 1) {
			//National Assembly
			delimitationService
				.getDistricts()
				.then((resp) => {
					setIsLoading(false);
					const districts = (Array.isArray(resp) ? resp : []).map((d) => ({
						key: `district-${d.id}`,
						data: { ...d, name: `${d.code} - ${d.name}` },
						children: [],
						leaf: false
					}));
					setNodes(districts);
				})
				.catch(() => setNodes([]));
		} else {
			//Local government
			delimitationService
				.getLocalDistricts()
				.then((resp) => {
					setIsLoading(false);
					const districts = (Array.isArray(resp) ? resp : []).map((d) => ({
						key: `Local District-${d.id}`,
						data: { ...d, name: `${d.code} - ${d.name}` },
						children: [],
						leaf: false
					}));
					setNodes(districts);
				})
				.catch(() => setNodes([]));
		}
	};

	const fetchConstituencies = async (districtNode) => {
		setdermacationForm((prev) => ({
			...prev,
			districtID: districtNode?.data?.id,
			districtName: districtNode.data.name
		}));

		if (!districtNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getConstituenciesByDistrict(districtNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((c) => ({
				key: `constituency-${c.id}`,
				data: { ...c, name: `${c.code} - ${c.name}`, ParentNode: districtNode },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching constituencies:", err);
			return [];
		}
	};

	const fetchCouncils = async (districtNode) => {
		setdermacationForm((prev) => ({
			...prev,
			districtID: districtNode?.data?.id,
			districtName: districtNode.data.name
		}));

		if (!districtNode?.data) return [];
		setIsLoading(true);

		try {
			const resp = await delimitationService.getCouncilsByDistrict(districtNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((c) => ({
				key: `Councils-${c.id}`,
				data: { ...c, name: `${c.code} - ${c.name}`, ParentNode: districtNode },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching councils:", err);
			return [];
		}
	};

	const fetchVotingDistricts = async (constituencyNode) => {
		setdermacationForm((prev) => ({
			...prev,
			constituencyID: constituencyNode?.data?.id,
			constituencyName: constituencyNode.data.name
		}));

		if (!constituencyNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getPollingDivisionsByConstituency(constituencyNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `votingdistrict-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, ParentNode: constituencyNode },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching voting districts:", err);
			return [];
		}
	};

	const fetchElectoralDivision = async (constituencyNode) => {
		setdermacationForm((prev) => ({
			...prev,
			constituencyID: constituencyNode?.data?.id,
			constituencyName: constituencyNode.data.name
		}));

		if (!constituencyNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.GetLocalVotingDistrictsByCouncilIdAsync(constituencyNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `Electoral Division-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, ParentNode: constituencyNode },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching voting districts:", err);
			return [];
		}
	};

	const fetchVotingStationsOrPollingCentre_registrationCentre = async (node) => {
		if (selectedDemarcation?.id == 1) {
			return await fetchVotingStations(node);
		} else if (selectedDemarcation?.id == 2) {
			return await fetchPollingCentre(node);
		}
	};

	const fetchVotingStations = async (votingDistrictNode) => {
		setdermacationForm((prev) => ({
			...prev,
			votingDistrictID: votingDistrictNode?.data?.id,
			votingDistrictName: votingDistrictNode.data.name
		}));

		if (!votingDistrictNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getRegistrationCentresByPollingDivision(votingDistrictNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((s) => ({
				key: `votingstation-${s.id}`,
				data: { ...s, name: `${s.code} - ${s.name}`, ParentNode: votingDistrictNode },
				children: [],
				leaf: false
			}));
		} catch (err) {
			console.error("Error fetching voting stations:", err);
			return [];
		}
	};

	const fetchPollingCentre = async (votingDistrictNode) => {
		setdermacationForm((prev) => ({
			...prev,
			votingDistrictID: votingDistrictNode?.data?.id,
			votingDistrictName: votingDistrictNode.data.name
		}));

		if (!votingDistrictNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.GetLocalVotingStationByElectorDivisionIDAsync(votingDistrictNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((s) => ({
				key: `votingstation-${s.id}`,
				data: { ...s, name: `${s.code} - ${s.name}`, ParentNode: votingDistrictNode },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching voting stations:", err);
			return [];
		}
	};
	const fetchVillages = async (registrationCentreNode) => {
		if (selectedDemarcation?.id == 1) {
			return await fetchNationalVillages(registrationCentreNode);
		} else if (selectedDemarcation?.id == 2) {
			return await fetchLocalVillages(registrationCentreNode);
		}
	};
	const fetchNationalVillages = async (registrationCentreNode) => {
		setdermacationForm((prev) => ({
			...prev,
			registrationCentreName: registrationCentreNode.data.name
		}));

		if (!registrationCentreNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getVillagesByRegistrationCentre(registrationCentreNode.data.id, true);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `village-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, actualVillageName: v.name, ParentNode: registrationCentreNode },
				children: [],
				leaf: true
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching villages:", err);
			return [];
		}
	};

	const fetchLocalVillages = async (registrationCentreNode) => {
		if (!registrationCentreNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getLocalVillagesByRegistrationCentre(registrationCentreNode.data.id, true);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `village-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, actualVillageName: v.name, ParentNode: registrationCentreNode },
				children: [],
				leaf: true
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching villages:", err);
			return [];
		}
	};

	const findParentChain = (key, tree, chain = []) => {
		for (let node of tree) {
			if (node.key === key) return chain;
			if (node.children && node.children.length > 0) {
				const found = findParentChain(key, node.children, [...chain, node]);
				if (found) return found;
			}
		}
		return null;
	};

	const handleSelectNode = (node) => {
		if (!node?.data) return;

		let newForm = { ...dermacationForm, level: node.data.delimitationLevelID };

		if (node.data.delimitationLevelID === 1) {
			newForm.districtID = node.data.id;
			newForm.districtName = node.data.name;
		} else {
			const parents = findParentChain(node.key, nodes) || [];

			parents.forEach((p) => {
				switch (p.data.delimitationLevelID) {
					case 1:
						newForm.districtID = p.data.id;
						newForm.districtName = p.data.name;
						break;
					case 2:
						newForm.constituencyID = p.data.id;
						newForm.constituencyName = p.data.name;
						break;
					case 3:
						newForm.votingDistrictID = p.data.id;
						newForm.votingDistrictName = p.data.name;
						break;
					case 4:
						newForm.registrationCentreName = node.data.name;
						if (selectedDemarcation?.id === 1) {
							newForm.registrationCenterNAID = p.data.id || null;
						} else if (selectedDemarcation?.id === 2) {
							newForm.registrationCenterLGID = p.data.id || null;
						}
						break;
				}
			});

			switch (node.data.delimitationLevelID) {
				case 3:
					newForm.votingDistrictID = node.data.id;
					newForm.votingDistrictName = node.data.name;
					newForm.registrationCenterNAID = null;
					newForm.status = node.data.status;
					break;
				case 5:
					const regParent = parents.find((p) => p.data.delimitationLevelID === 4);
					if (regParent) {
						newForm.registrationCentreName = regParent.data.name;
						if (selectedDemarcation?.id === 1) {
							newForm.registrationCenterNAID = regParent.data.registrationCenterNAID || null;
						} else if (selectedDemarcation?.id === 2) {
							newForm.registrationCenterLGID = regParent.data.registrationCenterLGID || null;
						}
					}
					break;
			}
		}

		setdermacationForm(newForm);
	};

	var userDelimitations = authenticationService.getUserDelimitation();
	const districts = userDelimitations.filter((x) => x.delimitationLevelID === 1 && x.districtID !== null);

	const allowedDistrictIds = new Set((districts || []).map((d) => d.districtID));
	const getDistrictIdForNode = (node) => {
		if (!node) return null;
		if (node.data?.delimitationLevelID === DermacationLevels.Level1) return node.data.id;

		const parents = findParentChain(node.key, nodes) || [];
		const districtParent = parents.find((p) => p.data?.delimitationLevelID === DermacationLevels.Level1);
		return districtParent?.data?.id ?? null;
	};

	const onTreeExpand = async (event) => {
		const node = event.node;
		if (!node || !node.data) return;
		setdermacationForm((prev) => ({
			...prev,
			DelimitationLevelID: node.data.delimitationLevelID
		}));

		if (!node.children || node.children.length === 0) {
			let children = [];
			if (node.data.delimitationLevelID === 3) {
				children = await fetchVotingStationsOrPollingCentre_registrationCentre(node);
			} else if (node.data.delimitationLevelID === 4) {
				children = await fetchVillages(node);
			} else if (selectedDemarcation?.id === 1) {
				if (node.data.delimitationLevelID === 1) children = await fetchConstituencies(node);
				else if (node.data.delimitationLevelID === 2) children = await fetchVotingDistricts(node);
			} else if (selectedDemarcation?.id === 2) {
				if (node.data.delimitationLevelID === 1) children = await fetchCouncils(node);
				else if (node.data.delimitationLevelID === 2) children = await fetchElectoralDivision(node);
			}
			const updateTree = (tree) =>
				tree.map((n) => {
					if (n.key === node.key) return { ...n, children };
					if (n.children && n.children.length > 0) return { ...n, children: updateTree(n.children) };
					return n;
				});

			setNodes((prev) => updateTree(prev));
		}
	};

	const findNodeByKey = (key, tree = nodes) => {
		for (let node of tree) {
			if (node.key === key) return node;
			if (node.children) {
				const found = findNodeByKey(key, node.children);
				if (found) return found;
			}
		}
		return null;
	};

	const openAddDialog = (node = null) => {
		if (!node) return;

		let newForm = { ...dermacationForm };

		if (node.data.delimitationLevelID === DermacationLevels.Level3) {
			newForm = {
				...newForm,
				code: "",
				name: "",
				description: "",
				parentCode: node.data?.code || "",

				districtID: node.data.ParentNode.data.ParentNode.data.id, //Level 1
				districtName: node.data.ParentNode.data.ParentNode.data.name, //Level 1
				districtCode: node.data.ParentNode.data.ParentNode.data.code, //Level 1

				constituencyID: node.data.ParentNode.data.id, //Level 2
				constituencyName: node.data.ParentNode.data.name,
				constituencyCode: node.data.ParentNode.data.code,

				votingDistrictID: node.data.id,
				votingDistrictName: node.data.name,
				votingDistrictCode: node.data.code,

				registrationCentreID: null, //Level 4
				registrationCentreName: null,

				villageID: null, //Level 5
				villageName: null,

				//selected Demarcation values
				DelimitationID: null,
				DelimitationLevelID: node.data.delimitationLevelID + 1,
				DelimitationParentID: node.data.id,
				registrationCenterNAID: null, //If level 5/Village
				registrationCenterLGID: null, //if leve5/village
				DelimitationNo: null
			};
		} else if (node.data.delimitationLevelID === DermacationLevels.Level4) {
			newForm = {
				...newForm,

				districtID: node.data.ParentNode.data.ParentNode.data.ParentNode.data.id, //Level 1
				districtCode: node.data.ParentNode.data.ParentNode.data.ParentNode.data.code, //Level 1
				districtName: node.data.ParentNode.data.ParentNode.data.ParentNode.data.name, //Level 1

				districtCode: node.data.ParentNode.data.ParentNode.data.code, //Level 1
				constituencyID: node.data.ParentNode.data.ParentNode.data.id, //Level 2
				constituencyCode: node.data.ParentNode.data.ParentNode.data.name,

				votingDistrictCode: node.data.ParentNode.data.ParentNode.data.code,
				votingDistrictID: node.data.ParentNode.data.ParentNode.data.id,
				votingDistrictName: node.data.ParentNode.data.ParentNode.data.name,

				registrationCentreCode: node.data.code, //Level 4
				registrationCentreID: node.data.id, //Level 4
				registrationCentreName: node.data.name,
				villageID: null, //Level 5
				villageName: null,

				//selected Demarcation values
				DelimitationID: null,
				DelimitationLevelID: node.data.delimitationLevelID + 1,
				DelimitationParentID: null,

				registrationCenterNAID: selectedDemarcation?.id == 1 ? node.data.id : null, //If level 5/Village
				registrationCenterLGID: selectedDemarcation?.id == 2 ? node.data.id : null, //if leve5/village

				DelimitationNo: null
			};
		} else {
			toast.current.show({
				severity: "warn",
				summary: "Add Restricted",
				detail: "You can only add under Voting District or Registration Centre"
			});
			return;
		}

		setdermacationForm(newForm);
		setTargetNode(node);
		setEditMode(false);
		setNodeName("");
		setDialogVisible(true);
	};

	const openEditDialog = (node) => {
		if (!node) return;
		const parents = findParentChain(node.key, nodes) || [];
		var newForm = {
			...dermacationForm,
			DelimitationID: node?.data?.id,
			DelimitationLevelID: node.data.delimitationLevelID,
			DelimitationParentID: node.data.ParentNode.data.id,
			name: node.data.name || "",
			code: node.data.code || "",
			description: node.data.description || "",
			status: node?.data?.status,
			VillageNode: null,
			node: node
		};

		if (node.data.delimitationLevelID === 4) {
			newForm.DelimitationNo = selectedDemarcation?.id == 1 ? node.data.registrationCentreNo : node.data.localRegistrationCentreNo;
		}
		if (node.data.delimitationLevelID === 5) {
			newForm.DelimitationNo = node.data.villageNo;
			newForm.registrationCenterNAID = node.data.registrationCenterNAID;
			newForm.registrationCenterLGID = node.data.registrationCenterLGID;
			newForm.villageName = node.data.actualVillageName;
			newForm.VillageNode = node;
		}
		setdermacationForm(newForm);
		setTargetNode(node);
		setEditMode(true);
		setNodeName(node.data?.name);
		setDialogVisible(true);
	};

	const openMoveDialog = (node) => {
		if (!node) return;

		var newForm = {
			...dermacationForm
		};

		if (node.data.delimitationLevelID === DermacationLevels.Level4) {
			newForm = {
				...newForm,
				districtID: node.data.ParentNode.data.ParentNode.data.ParentNode.data.id, //Level 1
				districtName: node.data.ParentNode.data.ParentNode.data.ParentNode.data.name, //Level 1
				districtCode: node.data.ParentNode.data.ParentNode.data.ParentNode.data.code, //Level 1

				constituencyID: node.data.ParentNode.data.ParentNode.data.id, //Level 2
				constituencyName: node.data.ParentNode.data.ParentNode.data.name,
				constituencyCode: node.data.ParentNode.data.ParentNode.data.code,

				votingDistrictID: node.data.ParentNode.data.id,
				votingDistrictName: node.data.ParentNode.data.name,
				votingDistrictCode: node.data.ParentNode.data.code,

				registrationCentreID: node.data.id, //Level 4
				registrationCentreName: node.data.name,

				villageID: null, //Level 5
				villageName: null,

				//selected Demarcation values
				DelimitationID: node?.data?.id,
				DelimitationLevelID: node.data.delimitationLevelID,
				DelimitationParentID: null,
				DelimitationNo: node.data.no,
				registrationCenterNAID: null, //If level 5/Village
				registrationCenterLGID: null //if leve5/village
			};
		}
		if (node.data.delimitationLevelID === DermacationLevels.Level5) {
			newForm = {
				...newForm,
				districtID: node.data.ParentNode.data.ParentNode.data.ParentNode.data.ParentNode.data.id, //Level 1
				districtName: node.data.ParentNode.data.ParentNode.data.ParentNode.data.ParentNode.data.name, //Level 1
				districtCode: node.data.ParentNode.data.ParentNode.data.ParentNode.data.ParentNode.data.code, //Level 1

				constituencyID: node.data.ParentNode.data.ParentNode.data.ParentNode.data.id, //Level 2
				constituencyName: node.data.ParentNode.data.ParentNode.data.ParentNode.data.name,
				constituencyCode: node.data.ParentNode.data.ParentNode.data.ParentNode.data.code,

				votingDistrictID: node.data.ParentNode.data.ParentNode.data.id,
				votingDistrictName: node.data.ParentNode.data.ParentNode.data.name,
				votingDistrictCode: node.data.ParentNode.data.ParentNode.data.code,

				registrationCentreID: node.data.ParentNode.data.id, //Level 4
				registrationCentreName: node.data.ParentNode.data.name,
				registrationCentreCode: node.data.ParentNode.data.code,

				villageID: node.data.id, //Level 5
				villageName: node.data.name,

				//selected Demarcation values
				DelimitationID: node?.data?.id,
				DelimitationLevelID: node.data.delimitationLevelID,
				DelimitationParentID: null,
				DelimitationNo: node.data.no,

				//Laave local registration centre null if moving village on local demarcation
				registrationCenterNAID: selectedDemarcation?.id == 2 ? node?.data?.registrationCenterNAID : null, //If level 5/Village

				//Laave national registration centre null if moving village on national demarcation
				registrationCenterLGID: selectedDemarcation?.id == 1 ? node?.data?.registrationCenterLGID : null //if leve5/village
			};
		}

		setdermacationForm(newForm);
		setTargetNode(node);
		setmoveDermacation(true);
		setNodeName(node.data?.name || "");
	};

	const updateNodeData = (tree, nodeId, level, newData) => {
		return tree.map((n) => {
			if (n.data.id === nodeId && n.data.delimitationLevelID === level) {
				return { ...n, data: { ...n.data, ...newData } };
			}
			if (n.children && n.children.length > 0) {
				return { ...n, children: updateNodeData(n.children, nodeId, level, newData) };
			}
			return n;
		});
	};

	const removeMovedNode = (tree, movedId) => {
		return tree
			.map((node) => {
				if (node.children?.length) {
					node = { ...node, children: removeMovedNode(node.children, movedId) };
				}
				return node;
			})
			.filter((node) => node.data.id !== movedId);
	};

	const onMoveDemarcationSubmit = async () => {
		try {
			setIsLoading(true);
			const payload = {
				isNationalDemarcation: selectedDemarcation?.id === 1,
				ID: dermacationForm.DelimitationID,
				DelimitationLevelID: dermacationForm.DelimitationLevelID,
				ParentID: dermacationForm.DelimitationParentID ?? null,
				registrationCenterNAID: dermacationForm.DelimitationLevelID === 5 ? dermacationForm.registrationCenterNAID : null,
				registrationCenterLGID: dermacationForm.DelimitationLevelID === 5 ? dermacationForm.registrationCenterLGID : null
			};

			setIsLoading(false);
			var res = await delimitationService.move(payload);

			setIsLoading(false);

			if (!res) throw new Error("No response from server");

			toast.current.show({
				severity: res.success ? "success" : "error",
				summary: "Message",
				detail: res.message,
				life: 2000
			});

			//Refresh the tree
			ResetDemarcationTreeAndResetForm(res.success);
		} catch (err) {
			console.error(err);
			setIsLoading(false);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Technical issue processing your request",
				life: 2000
			});
		}
	};
	const onCreateDemarcationSubmit = async () => {
		try {
			if (editMode) {
				return onUpdateDelimitationSubmit();
			}
			setIsLoading(true);

			const payload = {
				name: dermacationForm.name || nodeName,
				no: dermacationForm.DelimitationNo,
				code: dermacationForm.code || "",
				ParentID: dermacationForm.DelimitationParentID,
				DelimitationLevelID: dermacationForm.DelimitationLevelID,
				registrationCenterNAID: dermacationForm.registrationCenterNAID,
				registrationCenterLGID: dermacationForm.registrationCenterLGID,
				description: dermacationForm.description || "",
				isNationalDemarcation: selectedDemarcation?.id === 1,
				id: dermacationForm.DelimitationID
			};
			if (dermacationForm.DelimitationLevelID == 5) {
				payload.name = dermacationForm?.villageName;
			}

			setIsLoading(false);
			var res = await delimitationService.createDermacation(payload);

			setIsLoading(false);

			if (!res) throw new Error("No response from server");

			toast.current.show({
				severity: res.success ? "success" : "error",
				summary: "Message",
				detail: res.message,
				life: 2000
			});

			//Refresh the tree
			ResetDemarcationTreeAndResetForm(res.success);
		} catch (err) {
			console.error(err);
			setIsLoading(false);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Technical issue processing your request",
				life: 2000
			});
		}
	};
	const onUpdateDelimitationSubmit = async () => {
		try {
			setIsLoading(true);

			const payload = {
				name: dermacationForm.name || nodeName,
				no: dermacationForm.DelimitationNo,
				code: dermacationForm.code || "",
				ParentID: dermacationForm.DelimitationParentID,
				DelimitationLevelID: dermacationForm.DelimitationLevelID,
				registrationCenterNAID: dermacationForm.registrationCenterNAID,
				registrationCenterLGID: dermacationForm.registrationCenterLGID,
				description: dermacationForm.description || "",
				isNationalDemarcation: selectedDemarcation?.id === 1,
				id: dermacationForm.DelimitationID
			};

			if (dermacationForm.DelimitationLevelID == 5) {
				payload.name = dermacationForm?.villageName;
			}
			setIsLoading(false);
			var res = await delimitationService.updateDermacation(payload);

			setIsLoading(false);

			if (!res) throw new Error("No response from server");

			toast.current.show({
				severity: res.success ? "success" : "error",
				summary: "Message",
				detail: res.message,
				life: 2000
			});

			//Refresh the tree
			ResetDemarcationTreeAndResetForm(res.success);
			await refreshParentNode(dermacationForm?.node);
		} catch (err) {
			console.error(err);
			setIsLoading(false);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Technical issue processing your request",
				life: 2000
			});
		}
	};
	const ResetDemarcationTreeAndResetForm = async (refreshScreen = true) => {
		try {
			if (!refreshScreen) {
				return;
			}
			resetForm();

			const updateTreeChildren = async () => {
				if (!targetNode) return [];

				if (dermacationForm.DelimitationLevelID === DermacationLevels.Level4) {
					return selectedDemarcation?.id === 1 ? await fetchVotingStations(targetNode) : await fetchPollingCentre(targetNode);
				} else if (dermacationForm.DelimitationLevelID === DermacationLevels.Level5) {
					return selectedDemarcation?.id === 1 ? await fetchVillages(targetNode) : await fetchLocalVillages(targetNode);
				}
				return [];
			};

			setIsLoading(false);
			if (moveDermacation) {
				setNodes((prev) => removeMovedNode(prev, dermacationForm.id));
				resetForm();
				return;
			}

			if (editMode && targetNode) {
				const updatedName = dermacationForm.name || nodeName;
				const updatedCode = dermacationForm.code || "";
				const updatedNo = dermacationForm.no || null;
				const updatedDesc = dermacationForm.description || "";
				const displayName = updatedCode ? `${updatedCode} - ${updatedName}` : updatedName;

				const updatedData = {
					name: displayName,
					code: updatedCode,
					no: updatedNo,
					description: updatedDesc,
					registrationCenterNAID: selectedDemarcation?.id === 1 ? dermacationForm.registrationCenterNAID || null : undefined,
					registrationCenterLGID: selectedDemarcation?.id !== 1 ? dermacationForm.registrationCenterLGID || null : undefined
				};

				setNodes((prev) => updateNodeData(prev, dermacationForm.id, targetNode.data.delimitationLevelID, updatedData));
				setNodeName(displayName);
				resetForm();
				return;
			}

			if (!editMode && targetNode) {
				setdermacationForm((prev) => ({
					...prev,
					name: "",
					no: null,
					code: "",
					description: ""
				}));
				const children = await updateTreeChildren();
				setNodes((prev) => {
					const updateTree = (tree) =>
						tree.map((n) =>
							n.key === targetNode.key ? { ...n, children } : n.children ? { ...n, children: updateTree(n.children) } : n
						);
					return updateTree(prev);
				});
				resetForm();
			}
		} catch (err) {
			console.error(err);
			setIsLoading(false);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Technical issue refreshing the screen.",
				life: 2000
			});
		}
	};

	const resetForm = () => {
		setDialogVisible(false);
		setEditMode(false);
		setmoveDermacation(false);
		setNodeName("");
		setdermacationForm({
			...dermacationForm,
			name: "",
			no: null,
			code: "",
			description: ""
		});
	};

	const refreshParentNode = async (node) => {
		let children = [];
		if (node?.data.delimitationLevelID == 4) {
			children = await fetchVotingStationsOrPollingCentre_registrationCentre(node?.data.ParentNode);
		} else if (node?.data.delimitationLevelID == 5) {
			children = await fetchVillages(node?.data.ParentNode);
		}

		const updateTree = (tree) =>
			tree.map((n) => {
				if (n.key === node.data.ParentNode.key) return { ...n, children };
				if (n.children && n.children.length > 0) return { ...n, children: updateTree(n.children) };
				return n;
			});

		setNodes((prev) => updateTree(prev));
	};
	const handleDeactivate = (node) => {
		var data = node?.data;

		if (!data?.id) return;
		const newStatus = false;

		const payload = {
			id: data.id,
			status: newStatus,
			delimitationLevelID: data.delimitationLevelID
		};

		confirmDialog({
			message: "Are you sure you want to deactivate this item?",
			header: "Deactivate",
			icon: "pi pi-exclamation-triangle",
			accept: async () => {
				setIsLoading(true);

				try {
					const resp = await delimitationService.deactive(payload);
					setIsLoading(false);

					if (resp?.success) {
						toast.current.show({
							severity: "success",
							summary: "Success",
							detail: resp?.message,
							life: 3000
						});

						await refreshParentNode(node);
					} else {
						toast.current.show({
							severity: "error",
							summary: "Error",
							detail: resp?.message,
							life: 3000
						});
					}
				} catch (e) {
					setIsLoading(false);
					toast.current.show({
						severity: "error",
						summary: "Error",
						detail: "Technical issue processing your request",
						life: 3000
					});
				}
			},
			reject: () => {}
		});
	};
	const actionTemplate = (node) => {
		const nodeDistrictId = getDistrictIdForNode(node);
		const canActionDermacation = allowedDistrictIds.has(nodeDistrictId);

		return (
			<div className="flex gap-1">
				{node.data.delimitationLevelID >= DermacationLevels.Level3 && node.data.delimitationLevelID != DermacationLevels.Level5 && (
					<>
						{permission?.actions?.includes(permissionLookUp.Create) && canActionDermacation && (
							<Button
								icon="pi pi-plus"
								rounded
								type="button"
								severity="success"
								onClick={() => {
									openAddDialog(node);
								}}
							/>
						)}
					</>
				)}

				{node.data.delimitationLevelID > DermacationLevels.Level3 && canActionDermacation && (
					<>
						{permission?.actions?.includes(permissionLookUp.Delete) && (
							<>
								<Button
									icon="pi pi-pencil"
									type="button"
									tooltip="Edit Demarcation"
									rounded
									severity="info"
									onClick={() => openEditDialog(node)}
								/>

								<Button
									icon="pi pi-arrow-right-arrow-left"
									type="button"
									rounded
									severity="warning"
									tooltip="Move Demarcation"
									onClick={() => openMoveDialog(node)}
								/>
							</>
						)}
						{permission?.actions?.includes(permissionLookUp.Delete) && (
							<Button
								disabled={node.data.delimitationLevelID < 3}
								type="button"
								icon="pi pi-times"
								severity="danger"
								rounded
								tooltip="Click Deactivate"
								onClick={() => {
									handleDeactivate(node);
								}}
							/>
						)}
					</>
				)}
			</div>
		);
	};

	let levelNameMapNational;
	if (selectedDemarcation?.id === 1) {
		levelNameMapNational = {
			1: changeLang.get("national_delimitation.level1District"),
			2: changeLang.get("national_delimitation.level2ConstituencyCouncil"),
			3: changeLang.get("national_delimitation.level3PollingElectorDivision"),
			4: changeLang.get("national_delimitation.level4RegistrationCentre"),
			5: changeLang.get("national_delimitation.level5Village")
		};
	} else {
		levelNameMapNational = {
			1: changeLang.get("local_delimitation.level1District"),
			2: changeLang.get("local_delimitation.level2ConstituencyCouncil"),
			3: changeLang.get("local_delimitation.level3PollingElectorDivision"),
			4: changeLang.get("local_delimitation.level4RegistrationCentre"),
			5: changeLang.get("local_delimitation.level5Village")
		};
	}

	return (
		<div className="card p-4">
			<ConfirmDialog />
			<ScreenLoader visible={isLoading} />
			<Toast ref={toast} />
			<div className="grid mb-3">
				<div className="col-12 ">
					<h3>Select Demarcation type</h3>
					<Dropdown
						value={selectedDemarcation}
						placeholder="Select Demarcation type"
						className="w-full"
						showClear
						options={lookUp?.demarcationTypes}
						optionLabel="name"
						onChange={(e) => {
							const obj = e.value;
							setSelectedDemarcation(obj);
							const id = obj?.id ?? null;
							if (id != null) {
								fetchDistricts(e.value);
							} else {
								setNodes([]);
							}
						}}
					/>
				</div>
			</div>
			<div style={{ minWidth: "900px" }}>
				<TreeTable
					value={nodes}
					selectionMode="single"
					selectionKeys={selectedNodeKey}
					tableStyle={{ minWidth: "900px" }}
					resizableColumns
					scrollable
					onSelectionChange={(e) => {
						setSelectedNodeKey(e.value);
						const key = Object.keys(e.value)[0];
						const node = findNodeByKey(key);
						handleSelectNode(node);
					}}
					onExpand={onTreeExpand}
				>
					<Column field="name" header="Name" className="treetable-columns" expander style={{ widows: "350px" }} />
					<Column
						header="Level"
						className="treetable-columns"
						body={(node) => levelNameMapNational[node.data?.delimitationLevelID] ?? ""}
					/>
					<Column field="electorsCount" header="No. of Electors" className="treetable-columns" />
					<Column
						style={{ width: "200px", textAlign: "start" }}
						sortable
						field="isActive"
						header="Status"
						body={(e) => {
							const isActive = e.data.status == true;
							return isActive ? (
								<Button label="Active" className="p-button-success p-button-rounded" style={{ height: "30px" }} />
							) : (
								<Button label="Not Active" className="p-button-danger p-button-rounded" style={{ height: "30px" }} />
							);
						}}
					/>
					<Column header="Actions" body={actionTemplate} />
				</TreeTable>
			</div>
			<AddDermacation
				isNational={selectedDemarcation?.id === 1}
				dermacationForm={dermacationForm}
				setdermacationForm={setdermacationForm}
				showDialog={dialogVisible}
				setDialogVisible={setDialogVisible}
				editMode={editMode}
				nodeName={nodeName}
				setNodeName={setNodeName}
				onSave={onCreateDemarcationSubmit}
			/>

			<MoveDelimitations
				moveDermacation={moveDermacation}
				setmoveDermacation={setmoveDermacation}
				dermacationForm={dermacationForm}
				setdermacationForm={setdermacationForm}
				isNational={selectedDemarcation?.id === 1}
				nodeName={nodeName}
				onMove={onMoveDemarcationSubmit}
			/>
		</div>
	);
};
